module.exports = __webpack_public_path__ + "assets/handle.8f501a3d.svg";